<script>

    import BookmarkModal from './BookmarkModal.svelte';
    import { util } from '../utils/bookmarksUtil.js';
    import * as commonUtil from '../utils/commonUtil.js';
    import { dbUtil } from '../utils/dbUtil.js';
    import ShareHelpModal from '../utils/ShareHelpModal.svelte';
    import WelcomeCard from '../WelcomeCard.svelte';

    let bookmarksPromise = util.getBookmarks();
    let tagDetails = dbUtil.getTagsById();
    let bookmarksData = Promise.all([bookmarksPromise, tagDetails]);

    let showAddLinkModal = false;

    export let inputLink = null;
    if (inputLink != null && inputLink != '') {
        showAddLinkModal = true;
    }


    function closeBookmarkModal() {
        showAddLinkModal = false;
        inputLink = '';
        //If popup is triggered externally, it needs to auto-close after saving
        if (inputLink != null && inputLink != '') {
            window.close();
        }
    }

    async function loadData() {
        bookmarksPromise = util.getBookmarks(true);
        tagDetails = dbUtil.getTagsById(true);
        bookmarksData = Promise.all([bookmarksPromise, tagDetails]);
    }
    
    function parseLink(link) {
        if (link == null) {
            return 'Invalid link';
        }
        const urlObject = new URL(link);
        return urlObject.host;
    }

    let isHovered = false;
    let hoveredId = '';
    function setActive(event) {
        let id = event.target.id;
        isHovered = true;
        hoveredId = id;
    }
    function setInactive(event) {
        isHovered = false;
        hoveredId = '';
    }

    async function deleteBookmark(id) {
        let response = await util.deleteBookmark(id);
        if (response.success) {
            loadData();
        }
    }

</script>

<div id="bookmarks" class="font-thasadith-regular">
    {#await bookmarksData}
        <span class="info-text">...loading</span>
    {:then bookmarksAndTagsData}
        {#each bookmarksAndTagsData[0] as data}
            <a data-testid="bookmark" target="_blank" rel="noreferrer" href="{data.link}" class="bookmark" id="{data.id}" class:bookmark--hover="{isHovered && hoveredId == data.id}" 
                on:mouseenter={(event) => {setActive(event)}} on:mouseleave={(event) => {setInactive(event)}}>
                <div class="bookmark__img-container">
                    <!-- svelte-ignore a11y-invalid-attribute -->
                    <div class="bookmark__top-bar" class:bookmark__top-bar--visible="{isHovered && hoveredId == data.id}">
                        <a href="#">
                            <button class="delete-btn" on:click={deleteBookmark(data.id)} title="{commonUtil.getDeletionText('bookmark')}">
                                ✖
                            </button>
                        </a>
                    </div>
                    <!-- <img class="bookmark__img" src="{data.imageurl ? data.imageurl : 'img/bookmark-thumbnail-fallback.svg'}" alt="<link thumbnail>" /> -->
                </div>

                <div class="bookmark-content">
                    <div class="bookmark__title">
                        { data.title }
                    </div>
                    {#if data.description}
                        <div class="bookmark__description font-thasadith-italic" title={data.description}>
                            { data.description }
                        </div>
                    {/if}
                </div>
                <div class="bookmark-bottom">
                    <div class="bookmark__link">
                        { parseLink(data.link) }
                    </div>
                    <div class="bookmark__tags">
                        {#if data.tags != null && commonUtil.areAllTagsPresent(data.tags, Object.keys(bookmarksAndTagsData[1]), 'bookmarks')}
                            {#each data.tags as tagID}
                                <span class="tag" style="background-color: {(bookmarksAndTagsData[1])[tagID].color}; 
                                    color: {commonUtil.getContrastingColor((bookmarksAndTagsData[1])[tagID].color)}">
                                        {(bookmarksAndTagsData[1])[tagID].name}
                                </span>
                            {/each}
                        {/if}
                    </div>
                </div>
            </a>
        {/each}
        {#if bookmarksAndTagsData[0].length == 0}
            <div id="welcome-card">
                <WelcomeCard view="bookmarks"/>
            </div>
        {/if}
    {:catch error}
        Oops, there was an error! :(
        {error}
    {/await}

    <button id="add-button" on:click={() => {showAddLinkModal = true}}>&nbsp;+&nbsp;</button>

    {#if showAddLinkModal}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div class="modal-background" on:click={closeBookmarkModal}></div>
        <div class="modals">
            <div class="modal">
                <BookmarkModal inputLink={inputLink} on:saved="{loadData}" on:close="{closeBookmarkModal}"/>
            </div>

            {#if inputLink != null && inputLink != ''}
                <div class="modal share-help">
                    <ShareHelpModal msgContent={commonUtil.getAllQueryParams()}/>
                </div>
            {/if}
        </div>
    {/if}
</div>

<style>
    .modal-background {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0,0,0,0.3);
        color: black;
	}
    .modals {
        display: flex;
        flex-direction: column;
		position: absolute;
		left: 50%;
		top: 50%;
		width: calc(100vw - 4em);
		max-width: 32em;
		max-height: calc(100vh - 4em);
		overflow: auto;
		transform: translate(-50%,-50%);
	}
    .modal {
        padding: 0em 1em 1em 1em;
		border-radius: 0.2em;
        background: white;
        color: black;
        margin: 0.5em;
    }
    .modal.share-help {
        padding: 1em;
    }

    #bookmarks { 
        color: white;
        columns: 20em;
        column-gap: 1em;
        width: 100%;
    }
    
    .bookmark {
        display: inline-block;
        margin: 0 0 1em;
        padding: 0;
        width: 100%;
        border: 5px solid rgb(73, 73, 73);
        background-size: 100%;
        background-repeat:no-repeat;
        background-size: contain;
        background-position: 0px 1em;
        background-color: rgb(0, 0, 0, 0.5);
        background-blend-mode: darken;
        background: linear-gradient(to top, rgba(255, 255, 255, 0.1), transparent);
        border-radius: 2px;
        color: white;
        position: relative;
    }
    .bookmark--hover {
        border: 5px solid rgb(97, 97, 97);
        -webkit-box-shadow: -1px 1px 15px 5px rgba(73, 73, 73, 0.3); 
        box-shadow: -1px 1px 15px 5px rgba(73, 73, 73, 0.3);
    }
    .bookmark__img-container {
        position: relative;
    }
    .bookmark-bottom {
        margin-top: auto;
    }
    .bookmark__top-bar {
        position: absolute; 
        top:0; 
        right:0;
        padding: 0.2em;
        display: flex;
        column-gap: 0.7em;
        align-items: center;
        border-bottom-left-radius: 5px;
        opacity: 0;
    }
    .bookmark__top-bar--visible {
        opacity: 1;
    }

    .bookmark-content {
        margin: 1em;
        height: min-content;
    }
    .bookmark__title {
        font-weight: bold;
        font-size: 1.1em;
        word-break: break-word;
    }
    .bookmark__link {
        box-shadow: 2px 2px 6px 0px  rgba(0,0,0,0.3);
        text-decoration: none;
        background-color: rgb(0, 0, 0);
        color: rgb(196, 196, 196);
        overflow: hidden;
        overflow-x: auto;
        white-space: nowrap;
        height: min-content;
        padding: 0.5em;
        border-radius: 5px;
        margin: auto 1em;
    }
    .bookmark__description {
        font-style: italic;
        font-size: 0.9em;
        margin: 0.9em auto;
        max-height: 100%;
        white-space: pre-line;
        word-break: break-word;
    }

    a {
        color: lightblue;
        text-decoration: none;
        height: 100%;
    }
    .bookmark__tags {
        font-size: 0.8em;
        margin: 1em;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 10px;
        bottom: 0px;
    }
    .tag {
        padding: 0.3em 0.5em;
        border-radius: 5px;
    }
    #add-button {
        background-color: rgb(54, 54, 54);
        padding: 0.5em;
        position: absolute;
        bottom: 2em;
        right: 9%;
        border: 5px solid rgb(78, 78, 78);
        border-radius: 10em;
        font-weight: 900;
        font-size: 2em;
    }
    #url-link__label {
        font-style: italic;
    }
    #new-link__error {
        color: red;
        font-style: italic;
    }
    #new-link__success {
        color: green;
        font-style: italic;
    }
    #welcome-card {
        display: inline-block;
    }
    .delete-btn {
        background-color: rgb(44, 44, 44);
        color: rgb(238, 0, 0);
    }
    .delete-btn:hover {
        background-color: rgb(63, 63, 63);
    }
</style>